import { render, staticRenderFns } from "./MediaNewsList.vue?vue&type=template&id=33349e2f"
import script from "./MediaNewsList.vue?vue&type=script&lang=js"
export * from "./MediaNewsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports